module.exports = __webpack_public_path__ + "static/img/birdsbeasts_th.25d7589.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/birdsbeasts_th.png
// module id = UONs
// module chunks = 1